/**
 * Variables de entorno del SPA. (env)
 * Si hay `REACT_APP_NUA_PROXY_URL`, el REST `nuatalker` (useApi: consumption,
 * channels, virtual-agent, Phone Validator / propiedades `/ntpv`), NTAM, NTVA
 * (client_limit, editor/manage, pipelines, auditor, copilot, catálogo `/plan`),
 * NTHW, NTH Voice, Core/SMS (`nthsms`) y dialer v2 van al CDK. AppSync (agentes
 * en vivo), Usage muerto (`/client/v1`) y el PUT a S3 de WhatsApp/KB no.
 * Si no, Amplify `/proxy/...` y fallback al micro, como hasta ahora.
 */
import awsExports from '../aws-exports';

function read(name) {
  return String(process.env[name] || '').trim();
}

export function appEnv() {
  const raw = (read('REACT_APP_ENV') || read('REACT_APP_BRANCH') || 'dev').toLowerCase();
  return raw === 'main' ? 'main' : 'dev';
}

export function cognitoUserPoolId() {
  return read('REACT_APP_COGNITO_USER_POOL_ID') || awsExports.aws_user_pools_id || '';
}

export function cognitoClientId() {
  return (
    read('REACT_APP_COGNITO_CLIENT_ID') ||
    awsExports.aws_user_pools_web_client_id ||
    ''
  );
}

/** Base del API CDK (ej. https://api-dev.nuatalker.com/dev). Vacío = no se usa. */
export function nuaProxyUrl() {
  return read('REACT_APP_NUA_PROXY_URL').replace(/\/$/, '');
}

export function isCdkProxyConfigured() {
  return Boolean(nuaProxyUrl());
}

export function appConfig() {
  return {
    env: appEnv(),
    cognitoUserPoolId: cognitoUserPoolId(),
    cognitoClientId: cognitoClientId(),
    nuaProxyUrl: nuaProxyUrl(),
  };
}
